function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M37,34H13V16h24V34z M25,2C12.317,2,2,12.317,2,25s10.317,23,23,23s23-10.317,23-23S37.683,2,25,2z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeMiterlimit: 2.6131
    },
    x1: 29.178,
    y1: 25.331,
    x2: 40.309,
    y2: 34.049
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeMiterlimit: 2.6131
    },
    x1: 10.638,
    y1: 33.245,
    x2: 21.158,
    y2: 25.063
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeMiterlimit: 2.6131
    },
    d: "M10.169,16.098c0,0,12.086,10.447,12.836,11.099C23.754,27.85,24.534,28,25,28c0.466,0,1.246-0.149,1.996-0.802c0.749-0.653,12.242-10.631,12.242-10.631"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.73ee5ea7dee23afd0d060c927f1464c1.svg";
export { ForwardRef as ReactComponent };